import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { TokenResponse, WhoAmIResponse } from "types/api/user";

function useUserApi() {
    const { get, post } = useHttpManaged();
    const whoAmI = React.useCallback((options?: OptionsType, headers?: { [x: string]: string }): ResponseType<WhoAmIResponse> => {
        return get<undefined, undefined, WhoAmIResponse>({
            url: "/user/whoami",
            options: options,
            headers: headers
        });
    }, [get]);
    const refreshToken = React.useCallback((body: null, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<TokenResponse> => {
        return post<undefined, undefined, null, TokenResponse>({
            url: "/user/refresh-token",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    return {
        whoAmI,
        refreshToken
    };
}

export default useUserApi;